import type {ColorStorage} from '@Components/color-picker-v2';

export const GRADIENT_STOP_SWATCH_SIZE = 32;

export interface GradientStopSwatchesProps {
  color: ColorStorage[];
  selectedColorId: string;

  onChangeSelectedColor(id: string): void;
}
